import { render, staticRenderFns } from "./FiltersSkeleton.vue?vue&type=template&id=ff3e9e20"
import script from "./FiltersSkeleton.vue?vue&type=script&lang=js"
export * from "./FiltersSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports